<template>
  <div style="height:100%;overflow: hidden;">
    <div class="box">
      <img src="../../assets/img/icon/sucess.png"
           alt="">
      <h4>提交成功</h4>
      <p v-if="data!=null&&(data.liveType==1||data.liveType==2)">
        <span>{{num}}</span>
        <span>秒后自动跳转</span>
      </p>
      <div v-if="data!=null"
           class="text">
        <!-- <span>问卷标题：</span> -->
        <span>{{data.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      AuthorId: 0,
      qid: 0,
      num: 3,
      data: null,
      expireType:1
    }
  },
  created () {
    if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
      'qid')) {
      this.qid = this.$route.query.qid
      if (this.qid != 0) {
        this.getQuestion()
        if (localStorage.getItem('ResData')) {
          this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
        }
       
      }
    }
  },
  methods: {
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    getQuestion () {
      this.httphelper.get('/api/QuestionnaireApi/GetMeetingQualityInfo', {
        qId: this.qid
      }).then((res) => {
        if (res.code == 200) {
          this.data = res.data
           
          this.expireType = res.data.expireType
          this.getIsQuestion()
          var test2 = setInterval(() => {
            this.num--
            if (this.num == 0) {
              clearInterval(test2);
              if (this.data.liveType == 1) {
                this.$router.push({
                  path: '/muduLive?',
                  query: {
                    id: this.data.liveId,
                    mid: this.data.metid,
                  }
                })
              } else if (this.data.liveType == 2) {
                this.$router.push({
                  path: '/huodeLive?',
                  query: {
                    id: this.data.liveId,
                    mid: this.data.metid,
                  }
                })
              }
            }
          }, 1000)
        }
      })
    },
    getIsQuestion () {
      this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedbackList', {
        qid: this.qid,
        userid: this.AuthorId,
        expiretype:this.expireType
      }).then((res) => {
        if (res.code != 200) {
          this.$router.push({
            name: 'question',
            query: {
              qid: this.qid
            }
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.box {
    width: 300px;
    height: 160px;
    margin: 150px auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    p {
        font-size: 14px;
        color: rgb(99, 99, 99);
    }
    .text {
        width: 100%;
        padding: 20px 10px;
        margin-top: 30px;
        font-size: 15px;
        color: rgb(80, 80, 80);
        border-top: 1px solid #eee;
        text-align: center;
    }
}
@media screen and (min-width: 1024px) {
}
@media screen and (max-width: 1024px) {
    .box {
        .text {
            font-size: 14px;
        }
    }
}
</style>